import Api from '@common/services/api';
import { CompanyValue, CompanyValuePayload } from '../types';

export const createCompanyValue = async (
  organisationId: string,
  payload: CompanyValuePayload,
) => {
  return Api.post<{ data: CompanyValue }>(`/v1/organisations/${organisationId}/values`, payload);
};

export const updateCompanyValue = async (
  organisationId: string,
  valueId: string,
  payload: CompanyValuePayload,
) => {
  return Api.put<{ data: CompanyValue }>(`/v1/organisations/${organisationId}/values/${valueId}`, payload);
};

export const deleteCompanyValue = async (
  organisationId: string,
  valueId: string,
) => {
  return Api.delete<CompanyValue>(`/v1/organisations/${organisationId}/values/${valueId}`);
};
